export default __webpack_public_path__ + "1401204b52927f60345e58a0997b1512.png";